import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStatuspageComponent } from './simple-icons-statuspage.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStatuspageComponent ],
    exports:      [ SimpleIconsStatuspageComponent ],
    bootstrap:    []
})
export class SimpleIconsStatuspageModule {}
